import React, { useState, useEffect } from "react";
import PlayerCard from "./PlayerCard";
import Board from "./Board";
import { toast } from "react-hot-toast";
import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/esm/Card";
import Button from "react-bootstrap/esm/Button";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";

function Bingo() {
  const [board, setBoard] = useState([]);
  const [selectedTile, setSelectedTile] = useState();
  const [bingoNumbers, setBingoNumbers] = useState([]);
  const [selectionFlag, setSelectionFlag] = useState(false);
  const [readyToGen, setReadyToGen] = useState(true);
  const [letMeKnow, setLetMeKnow] = useState(false);
  const [win, setWin] = useState(false);
  const [readyToGenTrigger, setReadyToGenTrigger] = useState(false);
  const [messageTrigger, setMessageTrigger] = useState(false);
  const [speedSetting, setSpeedSetting] = useState(5);
  const [checkCard, setCheckCard] = useState(false);
  const [userSelect, setUserSelect] = useState({
    letter: "",
    location: -1,
    number: -1,
  });
  const [userTiles, setUserTiles] = useState([]);
  const [selectCoord, setSelectCoord] = useState();
  const [freeNum, setFreeNum] = useState(-1);
  const [play, setPlay] = useState(false);

  const checkUserSelection = () => {
    if (selectionFlag === true) {
      if (userSelect.number !== -1) {
        if (
          userSelect.number === board[board.length - 1].number ||
          (userSelect.letter === "N" &&
            userSelect.location === 2 &&
            userTiles.findIndex(
              (coords) =>
                coords.x === selectCoord.x && coords.y === selectCoord.y
            ) === -1)
        ) {
          if (selectCoord.x === 3 && selectCoord.y === 3) {
            selectedTile.style.backgroundColor = "#33a700";
            selectedTile.style.color = "white";
            toast("You have selected the FREE tile", {
              position: "bottom-right",
              duration: 3000,
            });
            setUserTiles((xy) => [
              ...xy,
              { x: selectCoord.x, y: selectCoord.y },
            ]);
          } else {
            selectedTile.style.backgroundColor = "#33a700";
            selectedTile.style.color = "white";
            toast("You selected the correct tile", {
              position: "bottom-right",
              duration: 3000,
            });
            setUserTiles((xy) => [
              ...xy,
              { x: selectCoord.x, y: selectCoord.y },
            ]);
            setReadyToGen(true);
            setMessageTrigger(false);
          }
        } else {
          toast("You did not select the correct tile.", {
            position: "bottom-right",
            duration: 3000,
          });
        }
        setUserSelect({
          letter: "",
          location: -1,
          number: -1,
        });
      }
      setSelectionFlag(false);
    }
  };

  const checkPlayerCard = () => {
    let onCard = false;
    if (readyToGen === false && userSelect.number === -1) {
      for (let i = 0; i < bingoNumbers.length; i++) {
        if (
          bingoNumbers[board[board.length - 1].location][i].number ===
          board[board.length - 1].number
        ) {
          if (letMeKnow === true) {
            toast("You have this tile on your Bingo Card.", {
              position: "top",
              duration: 3000,
            });
            onCard = true;
          }
          onCard = true;
        }
      }
      if (onCard === false) {
        setReadyToGenTrigger(true);
      }
    }
    setCheckCard(false);
  };

  useEffect(() => {
    if (readyToGenTrigger === true) {
      setTimeout(() => {
        setReadyToGen(true);
        setReadyToGenTrigger(false);
        setCheckCard(true);
      }, speedSetting * 1000);
    }
  }, [readyToGenTrigger]);

  useEffect(() => {
    if (checkCard === true) {
      checkPlayerCard();
    }
  }, [checkCard]);

  const checkHorzWin = () => {
    //check horizontal win
    let horzWin = 0;
    let row = 1;
    let col = 1;
    let sortedx = userTiles.sort((a, b) => a.x - b.x);
    sortedx = sortedx.sort((a, b) => a.y - b.y);
    do {
      for (let i = 0; i < userTiles.length; i++) {
        if (sortedx[i].x === 1) {
          col = 1;
        }
        if (sortedx[i].x === col && sortedx[i].y === row) {
          horzWin = horzWin + 1;
        }

        if (horzWin === 5) {
          toast("You win on row " + row + "!", {
            duration: 3000,
            position: "bottom-left",
          });
          setWin(true);
        }
        col = col + 1;
      }
      horzWin = 0;
      col = 1;
      row = row + 1;
    } while (row !== 6);
  };

  const checkVertWin = () => {
    //check vertical win
    let vertWin = 0;
    let row = 1;
    let col = 1;
    let sortedx = userTiles.sort((a, b) => a.y - b.y);
    sortedx = sortedx.sort((a, b) => a.x - b.x);
    do {
      for (let i = 0; i < userTiles.length; i++) {
        if (sortedx[i].y === 1) {
          row = 1;
        }
        if (sortedx[i].y === row && sortedx[i].x === col) {
          vertWin = vertWin + 1;
        }
        if (vertWin === 5) {
          toast("You win on col " + col + "!", {
            duration: 3000,
            position: "bottom-left",
          });
          setWin(true);
        }
        row = row + 1;
      }
      vertWin = 0;
      row = 1;
      col = col + 1;
    } while (col !== 6);
  };

  const checkCrossWin = () => {
    //check cross win
    let crossWin = 0;
    let crossWin2 = 0;
    let row = 1;
    let col = 1;
    let row2 = 1;
    let col2 = 5;
    let checkCount = 0;
    let sortedx = userTiles.sort((a, b) => a.x - b.x);
    sortedx = sortedx.sort((a, b) => a.y - b.y);
    do {
      for (let i = 0; i < userTiles.length; i++) {
        if (sortedx[i].y === row && sortedx[i].x === col) {
          crossWin = crossWin + 1;
        }
        if (crossWin === 5) {
          toast("You win on left cross!", {
            duration: 3000,
            position: "bottom-left",
          });
          setWin(true);
          break;
        }
        if (sortedx[i].y === row2 && sortedx[i].x === col2) {
          crossWin2 = crossWin2 + 1;
        }
        if (crossWin2 === 5) {
          toast("You win on right cross!", {
            duration: 3000,
            position: "bottom-left",
          });
          setWin(true);
          break;
        }
      }
      row = row + 1;
      col = col + 1;
      row2 = row2 + 1;
      col2 = col2 - 1;
      checkCount = checkCount + 1;
    } while (checkCount < userTiles.length);
  };

  const restartGame = () => {
    window.location.reload();
  };

  useEffect(() => {
    checkUserSelection();
    checkHorzWin();
    checkVertWin();
    checkCrossWin();
  }, [selectionFlag]);

  return (
    <>
      {play ? (
        !win ? (
          <>
      {/**<Card style={{ fontSize: "25px", paddingLeft: "20px" }}>
              <Form.Check
                type="switch"
                id="let-me-know"
                label="Pop-up when ball is on the player Card?"
                onClick={() => setLetMeKnow(!letMeKnow)}
              />
            </Card>*/}
            <Board
              setBoard={setBoard}
              readyToGen={readyToGen}
              setSelectionFlag={setSelectionFlag}
              freeNum={freeNum}
              setReadyToGen={setReadyToGen}
              setCheckCard={setCheckCard}
            />
            <PlayerCard
              setUserSelect={setUserSelect}
              setSelectionFlag={setSelectionFlag}
              selectionFlag={selectionFlag}
              setSelectedTile={setSelectedTile}
              setBingoNumbers={setBingoNumbers}
              setSelectCoord={setSelectCoord}
              setFreeNum={setFreeNum}
            />
          </>
        ) : (
          <>
            <Card style={{ padding: "10px", margin: "10px" }}>
              <Card.Header>Bingo</Card.Header>
              <Card.Body style={{ fontSize: "40px" }}>
                Congratulations on your win! To Restart your game press the
                restart game button below.
              </Card.Body>

              <Button onClick={() => restartGame()}>Restart Game</Button>
            </Card>
          </>
        )
      ) : (
        <>
          <Card style={{ padding: "10px", margin: "10px" }}>
            <Card.Header>Bingo</Card.Header>
            <Card.Body style={{ fontSize: "20px" }}>
              Ready to play? Press the Start Button below!
              <br />
              <br />
              <br />
              <div style={{ fontSize: "25px" }}>Settings:</div>
              <Form.Label style={{ textAlign: "center" }}>
                Seconds between calls. <b>Default is 5 seconds.</b>
              </Form.Label>
              <Row>
                <Col xs={1}>1</Col>
                <Col>
                  <Form.Range
                    onChange={(e) => setSpeedSetting(e.target.value)}
                    defaultValue={5}
                    min={1}
                    max={10}
                  />
                </Col>
                <Col xs={1}>10</Col>
              </Row>
              Seconds Between Calls: {speedSetting} seconds
            </Card.Body>

            <Button onClick={() => setPlay(true)}>Start Game</Button>
          </Card>
        </>
      )}
    </>
  );
}

export default Bingo;
